"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));
var _formatName = _interopRequireDefault(require("../../../utils/formatName"));
var _formatAddress = _interopRequireDefault(require("../../../utils/formatAddress"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _Item = _interopRequireDefault(require("./Item.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Item = _ref => {
  let {
    avoidDelete,
    data,
    lang,
    newItem,
    selected,
    selectable,
    onClickNew,
    onDelete,
    onEdit,
    onSelect
  } = _ref;
  const css = (0, _Item.default)();
  const {
    countryCode,
    countryTitle,
    company,
    defaultBilling,
    defaultShipping,
    firstName,
    id,
    lastName,
    phone,
    stateTitle,
    street,
    title,
    town,
    zipCode
  } = data || {};
  const name = (0, _formatName.default)({
    firstName,
    lastName,
    title
  });
  const address = (0, _formatAddress.default)({
    countryTitle,
    countryCode,
    stateTitle,
    street,
    town,
    zipCode
  });
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  if (newItem) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(css.item, "mco-shop-address-item", css.itemNew, "mco-shop-address-item--new"),
      onClick: onClickNew
    }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      src: "/img/icons/shop/add.svg",
      size: 36
    }), "Adresse hinzuf\xFCgen");
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.item, {
      [css.itemSelectable]: selectable,
      "mco-shop-address-item--selectable": selectable
    }, {
      [css.itemSelected]: selected,
      "mco-shop-address-item--selected": selectable
    }, "mco-shop-address-item"),
    onClick: () => {
      if (selectable && onSelect) onSelect(id !== null && id !== void 0 ? id : 0);
    }
  }, (company || name) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.title, "mco-shop-address-item__title"),
    dangerouslySetInnerHTML: {
      __html: company || name
    },
    variant: "body1"
  }), company && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.name, "mco-shop-address-item__name"),
    dangerouslySetInnerHTML: {
      __html: name
    },
    variant: "body2"
  })), address && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.address, "mco-shop-address-item__address"),
    dangerouslySetInnerHTML: {
      __html: address
    },
    variant: "body2"
  }), phone && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.phone, "mco-shop-address-item__phone"),
    dangerouslySetInnerHTML: {
      __html: phone
    },
    variant: "body2"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.defaults, "mco-shop-address-item__defaults")
  }, defaultShipping && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.defaultShipping, "mco-shop-address-item__default-shipping")
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "/img/icons/shop/check.svg"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.addresses.defaultShipping",
    l: l
  }))), defaultBilling && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.defaultBilling, "mco-shop-address-item__default-billing")
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: "/img/icons/shop/check.svg"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.addresses.defaultBilling",
    l: l
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.buttons, "mco-shop-address-item__buttons")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "mco-shop-address-item__button-edit",
    color: "primary",
    fullWidth: true,
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onEdit(id);
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.addresses.edit",
    l: l
  })), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "mco-shop-address-item__button-delete",
    color: "primary",
    disabled: avoidDelete,
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onDelete(id, address);
    },
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    className: css.icon,
    src: "/img/icons/shop/delete.svg",
    size: 24
  }))), selectable && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.select, "mco-shop-address-item__select")
  }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
    color: "primary",
    checked: selected,
    name: "address",
    value: id
  })));
};
var _default = exports.default = Item;